import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description: "These two filters are multiplied in the frequency domain. This intermediate result is shown below.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/18/principle/slide-03.svg`,
            },
          },
          styles: {
            padding: "0 5%",
          },
        },
      },
    },
  },
};

export default principle;
